import { Component, Input, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import * as powerbi from 'powerbi-client';
import { PowerbiStateService } from './services/powerbi-state.service';

@Component({
  selector: 'app-powerbi-embed',
  standalone: true,
  styleUrls: ['./powerbi-embed.component.scss'],
  template: `
    <div #powerbiContainer id="powerbi-container"></div>
  `,
})
export class PowerBiEmbedComponent implements OnInit, OnDestroy {
  @Input() embedUrl!: string | undefined;
  @Input() embedToken!: string | undefined;
  @ViewChild('powerbiContainer', { static: true }) powerbiContainer!: ElementRef;

  private report: powerbi.Report | undefined;

  constructor(private powerbiStateService: PowerbiStateService) {}

  ngOnInit() {
    this.embedReport();

    // Registrar este componente en el servicio para que otros componentes puedan acceder
    this.powerbiStateService.registerPowerBiComponent(this);
  }

  ngOnDestroy() {
    if (this.report) {
      this.report.off('loaded');
      this.report.off('rendered');
      this.report.off('error');
    }
    // Desregistrar el componente cuando se destruye
    this.powerbiStateService.unregisterPowerBiComponent();
  }

  /**
   * Captura el estado actual del reporte incluyendo filtros y slicers aplicados
   * @returns Promise con el bookmarkState o null si hay error
   */
  async captureBookmarkState(): Promise<string | null> {
    try {
      if (!this.report) {
        console.error('Report is not initialized');
        return null;
      }

      const bookmark = await (this.report as any).bookmarksManager.capture({
        allPages: true,
        personalizeVisuals: true,
      });
      const bookmarkState = bookmark.state;

      return bookmarkState;
    } catch (error) {
      console.error('Error capturing bookmark state:', error);
      return null;
    }
  }

  private embedReport() {
    if (!this.embedToken || !this.embedUrl) {
      console.error('Embed token or URL is missing.');
      return;
    }

    const models = powerbi.models;
    const timestamp = new Date().getTime();

    const embedConfig = {
      type: 'report',
      accessToken: this.embedToken,
      tokenType: models.TokenType.Embed,
      permissions: models.Permissions.All,
      embedUrl: `${this.embedUrl}&timestamp=${timestamp}`,
    };

    const powerbiService = new powerbi.service.Service(
      powerbi.factories.hpmFactory,
      powerbi.factories.wpmpFactory,
      powerbi.factories.routerFactory
    );

    this.report = powerbiService.embed(this.powerbiContainer.nativeElement, embedConfig) as powerbi.Report;

    this.report.on('loaded', () => {
      console.log('Power BI report loaded successfully.');
      this.report?.refresh();
    });

    this.report.on('rendered', () => {
      console.log('Power BI report rendered.');
    });

    this.report.on('error', (event) => {
      console.error('Power BI Error:', event);
    });
  }
}
